
import { commentMixIn } from '../utils'
import slots from '../mixins/slots.js'
const components_hash = {}
import { TEXT_FIELD } from '../type_name'
const context = require.context('./', true, /\.js$/);
 context.keys().map((path) => {
    if (path === './index.js') {
        return 
    }
    const obj = context(path).default
    if (components_hash[obj.name]) {
        console.error('form组件的name必须唯一');  
    }
    components_hash[obj.name] = obj
})  

export default new Proxy(components_hash, {
    get(target, type_key) {
        if (type_key === 'undefined') {
            return commentMixIn([slots, target[TEXT_FIELD]]) 
        }
        // console.log(target[type_key])
      if (!target[type_key]) {
         console.error(`暂无${type_key}类型的组件，如需要可自行注册`);  
      } else {
          return commentMixIn([slots, target[type_key]]) 
      }
    }
})

